
export default {
    API_BASEPATH: 'https://api.credumoney.com', 

   loan: {
      SEND_OTP: "/Api/Website/CreduMoneyLoanJourneyController/appCustomerRegisteration",
      VERIFY_OTP: "/Api/Website/CreduMoneyLoanJourneyController/appCustomerRegisteration",
      GET_DASHBOARD: "/Api/Website/CreduMoneyLoanJourneyController/getDashboardData",
      VERIFY_PAN: "/Api/Website/CreduMoneyLoanJourneyController/appCustomerRegisteration",
      PERSONAL_DETAILS: "/Api/Website/CreduMoneyLoanJourneyController/appCustomerRegisteration",
      INCOME_DETAILS: "/Api/Website/CreduMoneyLoanJourneyController/appCustomerRegisteration",
      ADDRESS_DETAILS: "/Api/Website/CreduMoneyLoanJourneyController/appCustomerRegisteration",
      CUSTOMER_DOCUMENT: "/Api/Website/CreduMoneyLoanJourneyController/saveleadDetails",
      STATE_CITY_PINCODE: "/Api/MasterController/masterAPI",
      UPLOAD_PROFILE_PIC: "/Api/Website/CreduMoneyLoanJourneyController/appCustomerRegisteration",
      PROFILE_PIC: "/Api/Website/CreduMoneyLoanJourneyController/appCustomerRegisteration",
      CHECK_ELIGIBILITY: "/Api/Website/CreduMoneyLoanJourneyController/appCustomerRegisteration",
      ABOUT_COMPANY: "/Api/Website/CreduMoneyLoanJourneyController/saveleadDetails",
      CALCULATE_LOAN: "/Api/Website/CreduMoneyLoanJourneyController/saveleadDetails",
      USER_DATA: "/Api/Website/getUser",
      ALL_LEADS: "/Api/Website/CreduMoneyLoanJourneyController/getLeadList",
      LOAN_DETAIL: "/Api/Website/CreduMoneyLoanJourneyController/getLeadDetail",
      GENERATE_LOAN: "/Api/Website/CreduMoneyLoanJourneyController/saveleadDetails",
      GENERATE_ORDER_ID: "/Api/Website/CreduMoneyLoanJourneyController/generateRazorpayorderId",
      MANDATORY_DOCS: "/Api/Website/CreduMoneyLoanJourneyController/check_customer_mandatory_documents",
   }
}


{/* <meta name="robots" content="noindex, nofollow" /> */ }